import './Individuals.css';
import '../App.css';

import TableResultsIndividuals from './TableResultsIndividuals';
import LayoutIndividuals from './LayoutIndividuals';

function Individuals2(props) {


  return (
    <div>
    <LayoutIndividuals collection={'Individuals'}  />
    
    </div>
  )
}

export default Individuals2